import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.16_@babel+core@7.28.5_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/link.js");
